import { applyMiddleware, createStore } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import ReduxThunk, { ThunkMiddleware } from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import reducers, { AppState } from "./";
import { ActionType } from "../actions/actionTypes";

const persistConfig = {
  key: "portalRoot",
  storage
};

// @ts-ignore
const persistedReducer = persistReducer(persistConfig, reducers);
const store = createStore(
  persistedReducer,
  {},
  composeWithDevTools(
    applyMiddleware(ReduxThunk as ThunkMiddleware<AppState, ActionType>)
  )
);
const persistor = persistStore(store);

export default { persistor, store };
